import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { uerActKC2SmrValueGql } from '../actFormulaQueries';

export const useActFormulaData = ({
    variables,
}: {
    variables: {
        actKC2Id: number;
        workOrderPriceId: number;
    };
}) => {
    const [data, status] = useRequest({
        query: uerActKC2SmrValueGql,
        variables,
        requestId: 'uerActKC2SmrValue',
    });

    const isLoading = status === RequestStatus.FETCHING;

    return {
        isLoading,
        formula: data?.uerActKC2SmrValue?.data?.formula,
    };
};
